import { Injectable, Injector } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';
import { MyHttpService } from '../../../../../services/myHttp/my-http.service';
import { StudentSubject, SubjectUnit } from '../../models/subject';
import { ServiceResult } from '../../../../../base-classes/service-result';
import { AppSettings } from '../../../../../utils/app-settings';
import { PreSignedUrl } from 'src/app/models/pre-signed-url';
import { HttpClient } from '@angular/common/http';
import { SyllabusProgress } from '../../models/syllabus-progress';

@Injectable({
  providedIn: 'root'
})
export class StudentSubjectsService {

  constructor(private http: HttpClient) { }

  get_all_subjects_for_student(): Observable<Array<StudentSubject>> {
    return this.http.get<Array<StudentSubject>>(AppSettings.apiUrl + "subjects");
  }

  get_all_units_for_subject(subject_id: number): Observable<Array<SubjectUnit>> {
    return this.http.get<Array<SubjectUnit>>(AppSettings.apiUrl + "subjects/" + subject_id + "/units");
  }

  getPresignedUrlOfLessonDoc(SubjectNoteId: number, attachmentId: number): Observable<PreSignedUrl>{
    return this.http.get<PreSignedUrl>(AppSettings.apiUrl + "subjects/notes/" + SubjectNoteId + "/attachment/" + attachmentId);
  }

  getUnitProgress(subjectId: number): Observable<SyllabusProgress>{
    return this.http.get<SyllabusProgress>(AppSettings.apiUrl + "subjects/"+subjectId+"/unitprogress" );
  }

}
